import _ from "lodash";
import { FETCH_MODELS, ADD_COMMENT } from "../actions";

export default function(state = {}, action) {
    switch (action.type) {
        case FETCH_MODELS:
            action.payload.modelosObj = action.payload.modelos;
            action.payload.modelos = _.map(action.payload.modelos, 'url');
            return action.payload;
        case ADD_COMMENT:
            return state;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/models_reducer.js